'use client';
import React, { useEffect } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import LogoRibbon from './components/LogoRibbon';
import HeroSection from './components/HeroSection';
import StatsCascade from './components/StatsCascade';
import ComparisonTable from './components/ComparisonTable';
import ROICalculator from './components/ROICalculator';
import InteractiveDemo from './components/InteractiveDemo';
import CTAStrip from './components/CTAStrip';

export default function HomePage() {
  // Scroll reveal observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    const revealEls = document.querySelectorAll('.reveal');
    revealEls?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <div className="grain min-h-screen bg-[#0D0D0D]">
      <Header />

      {/* Logo ribbon — directly under header */}
      <div className="pt-20">
        <LogoRibbon />
      </div>

      {/* Hero */}
      <HeroSection />

      {/* Divider */}
      <div className="section-divider mx-6 md:mx-24" />

      {/* Stats cascade — stats-first impact */}
      <StatsCascade />

      {/* Divider */}
      <div className="section-divider mx-6 md:mx-24" />

      {/* Comparison table — the inevitable vs. engine */}
      <ComparisonTable />

      {/* Divider */}
      <div className="section-divider mx-6 md:mx-24" />

      {/* ROI Calculator */}
      <ROICalculator />

      {/* Divider */}
      <div className="section-divider mx-6 md:mx-24" />

      {/* Interactive Demo */}
      <InteractiveDemo />

      {/* CTA strip */}
      <CTAStrip />

      <Footer />
    </div>
  );
}